import { WarningIcon } from '@chakra-ui/icons';
import { HStack, Text } from '@chakra-ui/react';

import PlainCheckIcon from '../Icons/PlainCheckIcon';

const ToastMessage = ({
  message,
  type,
  action,
}: {
  message: string;
  type: 'success' | 'error';
  action?: React.ReactNode;
}) => {
  let Icon;

  switch (type) {
    case 'success':
      Icon = PlainCheckIcon;
      break;
    case 'error':
      Icon = WarningIcon;
      break;
    default:
      Icon = null;
  }

  return (
    <HStack
      spacing='10px'
      color='brand.white'
      paddingX='24px'
      paddingY='22px'
      bg='blackAlpha.100'
      borderRadius='24px'
    >
      <Icon />
      <HStack spacing={12} justifyContent='space-between'>
        <Text variant='paragraphBold'>{message}</Text>
        {action}
      </HStack>
    </HStack>
  );
};

export default ToastMessage;
